// SYNC TO specTeam.Website!
export enum PaymentPresets
{
    Unset = "Unset",
    AllWithCash = "AllWithCash", // 💰+💰
    AllWithBankTransfer = "AllWithBankTransfer", // 💳+💳
    AllWithCrypto = "AllWithCrypto", // 🪙+🪙
    DepositWithBankTransfer_ServiceWithCash = "DepositPrepaidServicePostpaid", // 💳+💰
    DepositWithBlik_ServiceWithCash = "DepositPrepaidWithBlikServicePostpaid", // ☎️+💰
    // PartialDepositWithBankTransfer_ServiceWithCash = "PartialDepositPrepaidServicePostpaid",
    // FromPreviousOrder = "FromPreviousOrder",
    // CashAtDelivery = "CashAtDelivery"
}
